import styled from 'styled-components'
import CashinCashbackIcon from '../../../images/cashback/icon_cashback.svg'

export const StyledVaultCounter = styled.div`
  width: 300px;
  height: 100%;
  min-height: 300px;
  padding: 1rem;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 3em;
  align-items: center;
`

export const StyledProgress = styled.div`
  background: url(${CashinCashbackIcon}) 50% no-repeat;
  background-size: 75px;
  width: 210px;
  margin: 0 auto;

  .CircularProgressbar {
    width: 70%;
    margin: 0.5rem 0;
  }
`
